import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CreateOrEditState } from "./createoredit.reducer";

export const createOrEditFeatureKey = 'createOrEditFeatureKey';
export const createOrEditFeature = createFeatureSelector<CreateOrEditState>(
  createOrEditFeatureKey
)

export const selectIsLoadingTrafficData = createSelector(
  createOrEditFeature,
  state => state.fetchingTrafficData || state.fetchingRemarkData
)

export const selectIsSavingRemark = createSelector(
  createOrEditFeature,
  state => state.savingRemark
)

export const selectTrafficData = createSelector(
  createOrEditFeature,
  state => state.trafficData
)

export const selectRemarkData = createSelector(
  createOrEditFeature,
  state => state.remark
)

export const selectError = createSelector(
  createOrEditFeature,
  state => state.error
)
